module.exports = __webpack_public_path__ + "static/img/sx2.708a412.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/sx/sx2.png
// module id = rCtP
// module chunks = 0